const validator = require('validator');
const {ValidationError} = require('./exception.js');

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// チェックルーチン


// チェッカー関数のシグネチャ、およびサンプル
module.exports.not_empty = (value,option) =>{
    if(validator.isEmpty(value)) {
        let error = new ValidationError(`item '${option.item_name}' must not empty`);
        let item_name_readable=option.item_name;
        if('item_name_readable' in option) item_name_readable=option.item_name_readable;
        error.readableMessage=`${item_name_readable} を入力してください。`;
        throw error;
    }
}
module.exports.valid_url = (value,option) =>{
    if(validator.isURL(value) === false) {
        let error = new ValidationError(`item '${option.item_name}' must be valid URL`);
        let item_name_readable=option.item_name;
        if('item_name_readable' in option) item_name_readable=option.item_name_readable;
        error.readableMessage=`正しい ${item_name_readable} を入力してください。`;
        throw error;
    }
}
module.exports.valid_email = (value,option) =>{
    if(validator.isEmail(value) === false) {
        let error = new ValidationError(`item '${option.item_name}' must be valid Email address`);
        let item_name_readable=option.item_name;
        if('item_name_readable' in option) item_name_readable=option.item_name_readable;
        error.readableMessage=`正しい ${item_name_readable} を入力してください。`;
        throw error;
    }
}
